goog.provide("shadow.js.shim.module$src$svg$wpp$content$hub_svg$default");
shadow.js.shim.module$src$svg$wpp$content$hub_svg$default = shadow.js.shim.module$src$svg$wpp$content$hub_svg.default;
